import React from 'react';

import {Stack, Typography, useTheme} from '@mui/material';

import Icon from 'presentation/icons';
import {StyledBox} from './styles';
import {LocationOptionCardProps} from './types';

export function LocationOptionCard({
	iconName,
	label,
	onClick,
	isDisabled = false,
	dataTagId,
}: LocationOptionCardProps) {
	const theme = useTheme();

	return (
		<StyledBox onClick={onClick} data-tag-id={dataTagId}>
			<Stack gap={1} direction="row" alignItems={'center'}>
				<Icon
					name={iconName}
					size={24}
					color={isDisabled ? theme.palette.grey[400] : theme.palette.primary.main}
				/>
				<Typography variant="body2" color="text.primary">
					{label}
				</Typography>
			</Stack>
			<Icon name={'arrow-right-filled'} size={20} color={theme.palette.primary.main} />
		</StyledBox>
	);
}
